import {FC} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

interface LoaderProps {
    showLoader: boolean
}

const Loader: FC<LoaderProps> = ({ showLoader }) => {

    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
    }));
    const classes = useStyles();
    return (
        <Backdrop className={classes.backdrop} open={showLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}
export default Loader;